import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_CLAIMS_PATH,
  GetOrganizationClaimsErrorDto,
  GetOrganizationClaimsSuccessDto,
} from '@/api/rest/resources/types/organization';
import { usePlotGroupId } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

type SuccessDto = GetOrganizationClaimsSuccessDto;
type ErrorDto = GetOrganizationClaimsErrorDto;

export const useOrganizationClaims = (limit?: number, offset?: number, plotGroupIdArg?: string | null) => {
  const organizationId = useOrganizationId();
  const plotGroupId = usePlotGroupId();

  const pathParams = { organization_id: organizationId };
  const queryParams = {
    limit,
    offset,
    plot_group_id: plotGroupIdArg ?? plotGroupId,
  };

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_CLAIMS_PATH, pathParams, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', organizationId, 'claims', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
